import React from 'react'
import AutoCallList from './AutoCallList'

function GroupCallList() {
  return <AutoCallList listType="group" />
}

export default GroupCallList
